// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as OrderStatus from "../../../../library/data-source/order/entity/OrderStatus.bs.js";
import * as Icon$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CrmRepoManager from "../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as FilterOrderForm from "./FilterOrderForm.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as FilterOrderSource from "../entity/FilterOrderSource.bs.js";
import * as FilterOrderRequest from "../entity/FilterOrderRequest.bs.js";
import * as Timestamp$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as SeeMoreButton$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/SeeMoreButton.bs.js";
import * as TertiaryButton$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/TertiaryButton.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";

function reloadTab(filter, workspaceDispatch) {
  return Curry._1(workspaceDispatch.replaceTab, {
              TAG: /* FilterOrders */40,
              _0: FilterOrderRequest.toDict(filter)
            });
}

function setInitState(params) {
  return {
          filter: FilterOrderRequest.fromDict(params),
          data: {
            TAG: /* Loading */0,
            _0: undefined
          }
        };
}

function loadData(filter, offset, dispatch, loadedData, country) {
  var orders = offset !== undefined ? loadedData : undefined;
  Curry._1(dispatch, {
        TAG: /* BeforeDataFetch */1,
        data: {
          TAG: /* Loading */0,
          _0: orders
        },
        filter_request: filter
      });
  var RepoInstance = CrmRepoManager.getFilterOrderRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchOrders, filter, offset, country);
              }), (function (res) {
                return Curry._1(dispatch, {
                            TAG: /* SetData */0,
                            data: {
                              TAG: /* Live */1,
                              _0: Pervasives.$at(Belt_Option.getWithDefault(orders, /* [] */0), res.orders)
                            },
                            offset: res.offset,
                            end_of_list: List.length(res.orders) === 0,
                            total_items: res.total_orders
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetData */0,
                            data: {
                              TAG: /* Error */2,
                              _0: error
                            },
                            offset: undefined,
                            end_of_list: false,
                            total_items: 0
                          });
              }));
}

function tableConfig(workspaceDispatch, visibleKey, showData, pageAccessType) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "ID"
            },
            accessor: (function (apr) {
                return {
                        TAG: /* Custom */5,
                        _0: (function (param) {
                            return React.createElement(React.Fragment, undefined, React.createElement(TertiaryButton$Catalyst.make, {
                                            onSelectCB: (function (param) {
                                                return Curry._2(workspaceDispatch.addTab, {
                                                            TAG: /* OrderDetails */10,
                                                            _0: apr.order_id,
                                                            _1: undefined
                                                          }, false);
                                              }),
                                            children: apr.order_id
                                          }));
                          })
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Source"
              },
              accessor: (function (apr) {
                  return {
                          TAG: /* Text */0,
                          _0: FilterOrderSource.toString(apr.source)
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Customer"
                },
                accessor: (function (apr) {
                    return {
                            TAG: /* Text */0,
                            _0: apr.customer.name
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Driver"
                  },
                  accessor: (function (apr) {
                      return {
                              TAG: /* Custom */5,
                              _0: (function (param) {
                                  return React.createElement(React.Fragment, undefined, Belt_Option.mapWithDefault(apr.driver, "NA", (function (driver) {
                                                    return React.createElement(TertiaryButton$Catalyst.make, {
                                                                onSelectCB: (function (param) {
                                                                    return Curry._2(workspaceDispatch.addTab, {
                                                                                TAG: /* DriverDashboardV2 */5,
                                                                                _0: driver.msisdn
                                                                              }, false);
                                                                  }),
                                                                children: driver.msisdn
                                                              });
                                                  })), React.createElement("div", undefined, Belt_Option.mapWithDefault(apr.driver, "NA", (function (driver) {
                                                        return driver.name;
                                                      }))));
                                })
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Start Address"
                    },
                    accessor: (function (apr) {
                        return {
                                TAG: /* Custom */5,
                                _0: (function (param) {
                                    return React.createElement(SeeMoreButton$Catalyst.make, {
                                                msg: apr.start_address_landmark,
                                                length: 40
                                              });
                                  })
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "End Address"
                      },
                      accessor: (function (apr) {
                          return {
                                  TAG: /* Custom */5,
                                  _0: (function (param) {
                                      return React.createElement(SeeMoreButton$Catalyst.make, {
                                                  msg: OptionTypeUtils$Catalyst.getEmptyStringFrmOptionalType(apr.end_address_landmark),
                                                  length: 40
                                                });
                                    })
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Order Date"
                        },
                        accessor: (function (apr) {
                            return {
                                    TAG: /* Text */0,
                                    _0: Timestamp$Catalyst.toString(apr.created_at, "DD-MM-YYYY h:mm a")
                                  };
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "Vehicle"
                          },
                          accessor: (function (apr) {
                              return {
                                      TAG: /* Text */0,
                                      _0: apr.vehicle_type
                                    };
                            })
                        },
                        tl: {
                          hd: {
                            column: {
                              TAG: /* Text */0,
                              _0: "Status"
                            },
                            accessor: (function (apr) {
                                return {
                                        TAG: /* Text */0,
                                        _0: OrderStatus.toString(apr.order_status)
                                      };
                              })
                          },
                          tl: {
                            hd: {
                              column: {
                                TAG: /* Text */0,
                                _0: "Edit"
                              },
                              accessor: (function (apr) {
                                  return {
                                          TAG: /* Custom */5,
                                          _0: (function (param) {
                                              return React.createElement(RoundedPrimaryButton$Catalyst.make, {
                                                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                                                TAG: /* Text */0,
                                                                _0: "Edit"
                                                              }, undefined, (function (param) {
                                                                  return Curry._2(workspaceDispatch.addTab, {
                                                                              TAG: /* OrderDetails */10,
                                                                              _0: apr.order_id,
                                                                              _1: true
                                                                            }, false);
                                                                }), undefined, Caml_option.some(React.createElement(Icon$Catalyst.EditIcon.make, {
                                                                        fontSize: "Small"
                                                                      })), undefined, undefined, undefined, undefined, undefined)
                                                        });
                                            })
                                        };
                                })
                            },
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function FilterOrderConfig$T$FilterForm(Props) {
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  return React.createElement(FilterOrderForm.make, {
              filter: filter,
              applyFilter: applyFilter,
              total_items: total_items
            });
}

var FilterForm = {
  make: FilterOrderConfig$T$FilterForm
};

var T = {
  setInitState: setInitState,
  pageTitle: "Filtered Orders",
  loadData: loadData,
  reloadTab: reloadTab,
  tableConfig: tableConfig,
  FilterForm: FilterForm
};

export {
  T ,
  
}
/* react Not a pure module */
